<div id="watermark" [innerHTML]="'LICENCES.EXPIRED_LICENCE' | translate: {br: '<br/>'}">
</div>

<router-outlet></router-outlet>

<app-spinner></app-spinner>
<app-alert></app-alert>
